import { render, staticRenderFns } from "./GatewayDetail.vue?vue&type=template&id=4a93d4d7&scoped=true&"
import script from "./GatewayDetail.vue?vue&type=script&lang=js&"
export * from "./GatewayDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a93d4d7",
  null
  
)

export default component.exports